// ===================  AUTOMATICALLY GENERATED  ===========================
// Any edits made to this file will be overwritten on the next source code modification
// Edit comments in files directly, changes will be picked up and placed here

export const docs = [
  {
    "type": "overview",
    "categories": [
      "misc"
    ],
    "name": "CMS",
    "props": [],
    "args": [],
    "return": "",
    "text": "/* \n  Launchpad is set up so that all you need to do to create a dynamic, editable\n  page is use a few basic components within your code, no additional piping or\n  back end work required. The most basic components are:\n\n  `<Page />`\n  `<Snip />`\n  `<Image />`\n\n  All of these components can be imported from launchpad, e.g.:\n  `import { Page, Snip, Image } from 'launchpad'`\n\n  To create a new dynamic page, just create a new .jsx file in the `src/components/pages`\n  directory and use the `<Page />` component anywhere in the file. The dev server\n  will take care of the rest of the piping automatically. Then use the `Snip` and\n  `Image` components within the `<Page />` and voila, you have an editable page\n  that's automatically integrated with the CMS. For example:\n\n  Create a file at `src/components/pages/Test.jsx`:\n\n  ```js\n  import React from 'react'\n  import { Page, Snip, Image } from 'launchpad'\n\n  export default function TestPage() {\n    return <Page id='test-page'>\n      <Snip name='main-text' />\n      <Image name='image-1' />\n    </Page>\n  }\n\n  \\/\\/ launchpad_url: /test/page\n  ```\n\n  You could optionally pass in a `page` prop to the Snip and Image, but by default\n  they will pick up the id (`test-page`) from the Page component automatically\n  via React's context API.\n\n  Also notice the `\\/\\/ launchpad_url:` comment at the bottom, there are certain\n  attributes which can be set for the CMS via these types of comments. The most\n  useful ones are:\n\n  - `\\/\\/ launchpad_url: <relative url>` - the url of the page in the CMS\n  - `\\/\\/ launchpad_noindex: true` - if a value is set to this property the page will be hidden, e.g. hiding a WIP page to deploy other work\n  - `\\/\\/ launchpad_title: <Title>` - the title of the page\n\n\n  For admin dashboard pages, these can be useful as well\n  - `\\/\\/ launchpad_type: admin` - hides the page from the \"All Pages\" list\n  - `\\/\\/ launchpad_admin_panel: true` - adds a link to the page to the context pane\n  - `\\/\\/ launchpad_icon: <icon name (font awesome)>` - sets the icon for the context pane link\n\n*/",
    "file": "launchpad/admin/widgets/page.jsx",
    "location": 0
  },
  {
    "type": "component",
    "categories": [
      "sections"
    ],
    "name": "ContentBlock",
    "props": [
      "name - (String) must be different from other content blocks in the same page context",
      "page - (String) typically passed implicitly, if placed inside a <Page> component, this property is redundant"
    ],
    "args": [],
    "return": "",
    "text": "/*\n  \n\n  Generic, user-configurable content block, typically only a `name` prop is necessary\n\n*/",
    "file": "src/components/sections/ContentBlock.jsx",
    "location": 110
  },
  {
    "type": "component",
    "categories": [
      "templates"
    ],
    "name": "CustomPage",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n\n  DO NOT REMOVE THIS TEMPLATE if you are planning on using launchpad's builtin\n  page builder, this template is used by launchpad to generate custom pages used\n  in\n\n*/",
    "file": "src/components/templates/CustomPage.jsx",
    "location": 31
  },
  {
    "type": "component",
    "categories": [
      "CMS",
      "core"
    ],
    "name": "Image",
    "props": [
      "page - (String) which page this image is displayed on, typically unnecessary as it can be picked up from the Page Context",
      "name - (String) a unique name for this piece of text (or a shared name for shared data)",
      "img - (Boolean) set this property to use an <img /> tag instead of the default div with background image"
    ],
    "args": [],
    "return": "",
    "text": "/* \n   An `Image` is a flexible, editable image that is automatically\n   set up for user editing when a launchpad user is logged in\n\n*/",
    "file": "launchpad/admin/widgets/Image.jsx",
    "location": 75
  },
  {
    "type": "component",
    "categories": [
      "CMS",
      "core"
    ],
    "name": "Page",
    "props": [
      "id - (String) a unique identifier for this page, used for namespacing text/image data"
    ],
    "args": [],
    "return": "",
    "text": "/*\n  \n  Basis for CMS functionality. Essentially just a context provider for `<Snip />`\n  and `<Image />` components, but it also ensures all pages have a similar root\n  DOM structure which simplifies some of the core styling\n\n*/",
    "file": "launchpad/admin/widgets/page.jsx",
    "location": 59
  },
  {
    "type": "component",
    "categories": [
      "CMS",
      "core"
    ],
    "name": "Snip",
    "props": [
      "page - (String) which page this text, typically unnecessary as it can be picked up from the Page Context",
      "name - (String) a unique name for this piece of text (or a shared name for shared data)"
    ],
    "args": [],
    "return": "",
    "text": "/* \n   A `Snip` is a flexible, editable text box (WYSIWYG) that is automatically\n   set up for user editing when a launchpad user is logged in\n*/",
    "file": "launchpad/admin/widgets/snips.jsx",
    "location": 104
  },
  {
    "type": "overview",
    "categories": [
      "misc"
    ],
    "name": "api interaction",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n\n  Obviously you can just use fetch (or whatever method you prefer), but the standard\n  builtin CMS interaction is wired through the `apiRequest` function with automatic\n  prefixing. These functions assume your api can read JSON formatted data and expect\n  JSON data in return which is automatically parsed.\n\n  That means in practice you can send things like `{data: 'information'}` and expect\n  a response like `{success: true}` (no stringify or parsing needed).\n*/",
    "file": "launchpad/index.jsx",
    "location": 76
  },
  {
    "type": "function",
    "categories": [
      "api interaction",
      "core"
    ],
    "name": "apiGet",
    "props": [],
    "args": [
      "route - (String) the url you would like to send a GET request to"
    ],
    "return": "\n<Promise> parsed response from API",
    "text": "/*\n  \n\n  GET request from api (see apiRequest)\n\n */",
    "file": "launchpad/index.jsx",
    "location": 137
  },
  {
    "type": "function",
    "categories": [
      "api interaction",
      "core"
    ],
    "name": "apiPost",
    "props": [],
    "args": [
      "route - (String) the url you would like to send a POST request to",
      "data - (Object) data you wish to pass to the API"
    ],
    "return": "\n<Promise> parsed response from API",
    "text": "/*\n  \n\n  POST request to API (see apiRequest)\n\n */",
    "file": "launchpad/index.jsx",
    "location": 169
  },
  {
    "type": "function",
    "categories": [
      "api interaction",
      "core"
    ],
    "name": "apiRequest",
    "props": [],
    "args": [
      "route - (String) the route you would like to access (without `/api/v1` prefix)",
      "data - (Object) an object which will be converted to JSON and passed to the API",
      "method - (String) http method, e.g. `GET` or `POST`"
    ],
    "return": "\n<Promise> whatever the API returns in response to the given request (parsed)",
    "text": "/*\n  \n  Generic api request/response.  Requests are automatically prefixed with `/api/v1`,\n  the standard express based API is already built to mirror that approach, but when\n  integrating with an existing api you'll either need to remove the prefix here\n  or add it to the routes you create\n\n\n*/",
    "file": "launchpad/index.jsx",
    "location": 88
  },
  {
    "type": "variable",
    "categories": [
      "routing"
    ],
    "name": "customRoutes",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n  A variable containing any custom or ambiguous routes. When\n  adding new routes, you can just add to this array. Routes will be rendered\n  inside a `react-router` `<Switch>`, all of the standard `react-router` props\n  apply. these routes will be automatically combined with CMS routes. If\n  creating a single route which doesn't need ambiguous matching, consider just\n  creating a file in the `components/pages` directory (see CMS section), which\n  will automatically create a page, add it to the CMS's page index, and\n  automatically implement code splitting.\n*/",
    "file": "src/config/routes.jsx",
    "location": 23
  },
  {
    "type": "function",
    "categories": [
      "core"
    ],
    "name": "launchpadInit",
    "props": [],
    "args": [
      "app - (Component) e.g. `<App />`",
      "id - (String) the id of the DOM element where the app should be rendered"
    ],
    "return": "",
    "text": "/*\n  \n  use this function to initialize the app, it preloads most of the important\n  data from the API. Typically the default usage in /src/index.jsx won't need\n  to be adjusted.\n\n*/",
    "file": "launchpad/index.jsx",
    "location": 281
  },
  {
    "type": "variable",
    "categories": [
      "routing"
    ],
    "name": "qs",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n  Initialized as the query string parsed as a js object, which can be modified\n  and persisted to the query string via the `setQS` function. Import via:\n```\nimport { qs } from 'launchpad'\n```\n*/",
    "file": "launchpad/helpers/qs.js",
    "location": 2
  },
  {
    "type": "variable",
    "categories": [
      "routing",
      "CMS"
    ],
    "name": "refreshFunctions",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n  This function is used to register an async function that should be called when calculating\n  which routes are available to the CMS. Typically it will involve making an API\n  call, and then generating a list of routes from the data that's returned.\n  This approach is much less performant than statically adding routes, since these\n  async functions must complete before the first render. However, when adding\n  routes that depend upon dynamic data, such as blog posts or admin configuration,\n  calls to this function allow dynamic routes to be added and integrated with\n  other CMS functionality (e.g. editable menus)\n*/",
    "file": "src/config/routes.jsx",
    "location": 44
  },
  {
    "type": "overview",
    "categories": [
      "misc"
    ],
    "name": "routing",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n\n  Most basic routing is done automatically (see CMS section), manually adding routes\n  can be done in `/src/config/index.jsx`. Consider using the `<Page>` component,\n  following the instructions provided in the CMS section to take advantage\n  of the automatic CMS integration.\n*/",
    "file": "src/config/routes.jsx",
    "location": 0
  },
  {
    "type": "overview",
    "categories": [
      "misc"
    ],
    "name": "sections",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n  Sections are components representing blocks/rows of content, like a text/image row or a CTA.\n  Many of these components have builtin editable zones and configuration options.\n  Sections can typically be imported via:\n\n  ```\n    import {Section} from 'sections'\n  ```\n\n*/",
    "file": "src/components/sections/index.jsx",
    "location": 0
  },
  {
    "type": "function",
    "categories": [
      "routing"
    ],
    "name": "setQS",
    "props": [],
    "args": [
      "object - (object) an object containing keys/values to push to the query string (leave blank to reset value)"
    ],
    "return": "",
    "text": "/*\n  \n  A function to set variables in the query string. Similar in format to react's\n  `setState`, e.g. `setQS({name: value})`. Import via:\n```\nimport { setQS } from 'launchpad'\n```\n*/",
    "file": "launchpad/helpers/qs.js",
    "location": 14
  },
  {
    "type": "overview",
    "categories": [
      "misc"
    ],
    "name": "templates",
    "props": [],
    "args": [],
    "return": "",
    "text": "/*\n  \n\n  Templates are components that can be used to generate pages dynamically,\n  e.g. a product detail page, which might accept a route like `/products/:id`.\n  If a component is only used to generate a particular page, consider adding it\n  to the `components/pages` directory instead, where it will be automatically\n  integrated with the CMS and router. Templates will have to be integrated\n  manually (at least for now)\n\n*/",
    "file": "src/components/templates/CustomPage.jsx",
    "location": 0
  }
]
      